import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { HomeScreen } from "./screens/HomeScreen";
import { ReturnScreen } from "./screens/ReturnScreen";
import { VisitRoute } from "./screens/VisitScreen";
import { SupportChat } from "./support/SupportChat";

/** Served under /app/ (nginx), which is also the service-worker scope. */
export function App() {
  return (
    <BrowserRouter basename="/app">
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/visit/:id" element={<VisitRoute />} />
        {/* The payment page's return address (paymentReturn.ts). */}
        <Route path="/return" element={<ReturnScreen />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {/* Outside <Routes>: one chat for the whole app, kept across screens. */}
      <SupportChat />
    </BrowserRouter>
  );
}
